const updateCart = payload => {
    return {
        type: "updateCart",
        payload
    }
}

module.exports = {
    updateCart
}